(function (module) {
  'use strict';
  module
    .controller('pnrController', ['$scope', 'progressBar', 'ngDialog', '$state', '$stateParams', 'pnr',
      function ($scope, progressBar, ngDialog, $state, $stateParams, pnr) {
        const progress = progressBar.getProgressBar();
        $scope.pnrs = '';
        $scope.isProcessing = false;

        $scope.processPnr = function () {
          const isValidPnr = !!$scope.pnrs.length ? true : false;
          const pnrRegex = /^\w+(,\s*\w+){0,2}$/;
          const isValidData = isValidPnr && pnrRegex.test($scope.pnrs) ? true : false;
          const arrPnr = isValidPnr ? $scope.pnrs.split(",") : [$scope.pnrs];
          if (!isValidPnr || arrPnr.length > 3 || !isValidData) {
            const dialog = ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '';
                if (!isValidPnr) {
                  $scope.errMsg += '<p>PNR must be entered.</p>';
                }
                if (arrPnr.length > 3 || !isValidData) {
                  $scope.errMsg += '<p>Maximum 3 valid PNR seperated by comma(,) allow to process.</p>';
                }
                $scope.errTitle = 'Process PNR Error';
              },],
            });
            dialog.closePromise.then(function (data) { });
          } else {
            $scope.isProcessing = true;
            progress.start();
            pnr.processingPnr(arrPnr).then(function (response) {
              $scope.isProcessing = false;
             const dialogPost = ngDialog.open({
                template: 'templates/partials/viewSuccessMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.strTitle = 'Process PNR Success';
                  $scope.successMsg = 'PNRs process successfully';
                },],
              });
              dialogPost.closePromise.then(function (data) {
                $state.go('app.dashboard');
              });
            }, function (err) {
              $scope.isProcessing = false;
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${err.statusText} : ${err.data}</p>`;
                  $scope.errTitle = 'Process PNR Error';
                },],
              });
            }).finally(function () {
              progress.complete();
            });
          }
        }

        $scope.cancelProcess = function () {
          $state.go('app.dashboard');
        }
        $scope.$watch(function () {
        }, function (newValue, oldValue) {
        }, true);
      },
    ]);
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/controllers/pnrController.js